export const NewWayIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95849 20.7581C8.38612 21.9114 10.0189 21.9114 10.4465 20.7581L11.3665 18.283C11.6776 17.4537 12.3255 16.8058 13.1548 16.4948L15.6299 15.5747C16.7832 15.1471 16.7832 13.5143 15.6299 13.0867L13.1548 12.1667C12.3255 11.8557 11.6776 11.2077 11.3665 10.3784L10.4465 7.90335C10.0189 6.75005 8.38612 6.75005 7.95849 7.90335L7.03844 10.3784C6.89376 10.7916 6.65787 11.1669 6.34829 11.4765C6.03871 11.7861 5.66339 12.022 5.25018 12.1667L2.77513 13.0867C1.62183 13.5143 1.62183 15.1471 2.77513 15.5747L5.25018 16.4948C6.07952 16.8058 6.72744 17.4537 7.03844 18.283L7.95849 20.7581ZM20.269 13.631C20.5281 14.3177 21.5 14.3177 21.7592 13.631L22.3034 12.1537C22.4849 11.6742 22.8607 11.2984 23.3401 11.117L24.8174 10.5728C25.5042 10.3136 25.5042 9.34173 24.8174 9.08256L23.3401 8.53831C23.098 8.4592 22.8779 8.32409 22.6978 8.14397C22.5177 7.96384 22.3825 7.74377 22.3034 7.50163L21.7592 6.02438C21.5 5.33758 20.5281 5.33758 20.269 6.02438L19.7247 7.50163C19.6456 7.74377 19.5105 7.96384 19.3304 8.14397C19.1503 8.32409 18.9302 8.4592 18.688 8.53831L17.2108 9.08256C16.524 9.34173 16.524 10.3136 17.2108 10.5728L18.688 11.117C19.1675 11.2984 19.5433 11.6742 19.7247 12.1537L20.269 13.631Z"
        fill="white"
      />
    </svg>
  );
};
